import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class LanguageSelectorService {
  public isRtl: Subject<boolean> = new Subject();
  constructor() { }
}
